import { render, staticRenderFns } from "./tower-canvas.vue?vue&type=template&id=7e85cd70&scoped=true&"
import script from "./tower-canvas.vue?vue&type=script&lang=js&"
export * from "./tower-canvas.vue?vue&type=script&lang=js&"
import style0 from "./tower-canvas.vue?vue&type=style&index=0&id=7e85cd70&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e85cd70",
  null
  
)

export default component.exports